import { render, staticRenderFns } from "./index.vue?vue&type=template&id=76bf27f4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MyBalance: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/core/MyBalance.vue').default,NextDeliveryDate: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/core/NextDeliveryDate.vue').default,PublicProductsForm: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/forms/PublicProductsForm.vue').default,ShopClose: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/others/ShopClose.vue').default})
